module.exports = __webpack_public_path__ + "img/post_arrow_hover.737bb395.svg";